import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigureUrlErrorComponent} from './configure-url-error.component';
import {NetNewModule} from '../net-new/net-new.module';
import {DefaultConfiguratorErrorModule} from '../default-configurator-error/default-configurator-error.module';

@NgModule({
  declarations: [
    ConfigureUrlErrorComponent,
  ],
  imports: [
    CommonModule,
    NetNewModule,
    DefaultConfiguratorErrorModule,
  ],
  exports: [
    ConfigureUrlErrorComponent,
  ]
})
export class ConfigureUrlErrorModule {
}
